import React, { useState } from "react";
import { useTimer } from "hooks";
import { addCommasAndAnd, processText } from "core/utils/string";
import { HiddenDevOnlyOptions } from "components/HiddenDevOnlyButton";
import { desktop } from "submodules/sharedText/flavor";
import { CharacterList, CharacterListTitle } from "components/Character";

const { directory } = desktop;
const flavor = { ...directory };

const Directory = ({
  pause,
  onComplete,
  players,
  restartRound,
  restartRoundNoIntro,
}) => {
  const percent = useTimer(pause, flavor.timer, onComplete);
  const uniqueRoles = Array.from(new Set(players.map(({ role }) => role)));
  const currentRoles = addCommasAndAnd(uniqueRoles);

  return (
    <div data-test-id="directory-phase">
      <CharacterListTitle white>
        {processText(flavor.title).toLocaleUpperCase()}
      </CharacterListTitle>
      {players.length > 0 && <CharacterList players={players} />}
      <HiddenDevOnlyOptions
        onComplete={onComplete}
        percent={percent}
        restartRound={restartRound}
        restartRoundNoIntro={restartRoundNoIntro}
      />
    </div>
  );
};

export default Directory;
